import { render, staticRenderFns } from "./NoServiceProvidedScreen.vue?vue&type=template&id=7a066f83&scoped=true&"
import script from "./NoServiceProvidedScreen.vue?vue&type=script&lang=js&"
export * from "./NoServiceProvidedScreen.vue?vue&type=script&lang=js&"
import style0 from "./NoServiceProvidedScreen.vue?vue&type=style&index=0&id=7a066f83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a066f83",
  null
  
)

export default component.exports